module.exports = __webpack_public_path__ + "img/car-door.1c5da2ba.jpg";